export const JsInterstitialConfig = {
    wcmContent: null,
    modalId: 'js-interstitial',
    modalSize: 'modal-md',
    customModalStyle: { marginTop: '150px'},
    showClose: false,
    closeEvent:'Close',
    consentInterstitial: false,
    consentChecked: false,
    phoneValid: false,
    doNotDisplay: 'F',
    increaseViewCount: true,
    consentError: false
 }